import {createAction} from 'web-app/util/redux/typed-action-helpers';
import {type CurriculumModeType} from 'web-app/react/child-development/curriculum-builder/hook-reducer';

export const {action: show} = createAction(
    'CURRICULUM_BUILDER_MODAL/SHOW',
    (
        payload:
            | {mode: CurriculumModeType.New; institutionId: string}
            | {mode: CurriculumModeType.Edit; institutionId: string; curriculumId: string},
    ) => payload,
);
export const {action: hide} = createAction('CURRICULUM_BUILDER_MODAL/HIDE', () => ({}));
